// extracted by css-extract-rspack-plugin
export default {"EffectControllersContainer":"src-wab-client-components-style-controls-FilterEffectPanel-module__EffectControllersContainer-YfyisY","effectControllersContainer":"src-wab-client-components-style-controls-FilterEffectPanel-module__EffectControllersContainer-YfyisY","slider":"src-wab-client-components-style-controls-FilterEffectPanel-module__slider-nmVhx3","Dropdown":"src-wab-client-components-style-controls-FilterEffectPanel-module__Dropdown-GYXxZB","dropdown":"src-wab-client-components-style-controls-FilterEffectPanel-module__Dropdown-GYXxZB"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"EffectControllersContainer\":\"src-wab-client-components-style-controls-FilterEffectPanel-module__EffectControllersContainer-YfyisY\",\"effectControllersContainer\":\"src-wab-client-components-style-controls-FilterEffectPanel-module__EffectControllersContainer-YfyisY\",\"slider\":\"src-wab-client-components-style-controls-FilterEffectPanel-module__slider-nmVhx3\",\"Dropdown\":\"src-wab-client-components-style-controls-FilterEffectPanel-module__Dropdown-GYXxZB\",\"dropdown\":\"src-wab-client-components-style-controls-FilterEffectPanel-module__Dropdown-GYXxZB\"}";
        // 1793541995732
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  